import { FC, MouseEvent } from 'react';

import { useCardOfferDataContext } from 'shared/context/CardContext';
import { useCAForCard } from 'shared/hooks/useCAForCard';

import { BestPlaceAnalyticsLabel } from './BestPlaceAnalyticsLabel';

export const BestPlaceAnalyticsLabelContainer: FC = () => {
  const { url } = useCardOfferDataContext();
  const ca = useCAForCard();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    ca({ action: 'click_buy_report', category: 'Listing', label: 'geoanalytics_popup' });
    event.stopPropagation();
  };

  return <BestPlaceAnalyticsLabel url={`${url}?with_best_place=1`} onClick={handleClick} />;
};
